export const enums = {
  GAS: "gas",
  PETROL: "petrol",
};

export const mapping = {
  [enums.GAS]: "Газ",
  [enums.PETROL]: "Бензин",
};
